import { schema } from 'normalizr';

const noteSchema = new schema.Entity('notes', {
  user: new schema.Entity('users'),
});

export default noteSchema;
